import type { FunctionComponent } from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';

import { Gap } from '../../../shared/components/gap/gap';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { getAssetUrl } from '../../../shared/utils/get-asset-url';
import type { IFilters, IUserProfileFreeBetStatus } from '../../graphql/query.graphql';

import styles from './free-bet-card.module.scss';
const style = createStyleHelper(styles, 'free-bet-card');

export interface IFreeBetCardProps {
    className?: string;
    id: string;
    name: string;
    currency: string;
    expiresOn: string;
    grantedAmount: number;
    consumedGrantedAmount: number;
    balanceAmount: number;
    conversionMaxAmount: number;
    convertedAmount: number;
    status: IUserProfileFreeBetStatus;
    mediatorId: string;
    title: string;
    subtitle: string;
    description: string;
    image: string;
    filters?: IFilters;
}

export const FreeBetCard: FunctionComponent<IFreeBetCardProps> = ({
    className,
    currency,
    expiresOn,
    grantedAmount,
    title,
    image,
}) => {
    const imageUrl = getAssetUrl(image);

    return (
        <div className={createClassName([className, style()])}>
            {imageUrl ? <img className={style('image')} src={imageUrl} /> : null}
            <Gap className={style('content')}>
                <div className={style('label')}>
                    <FormattedMessage
                        id="account.free-bet.description"
                        defaultMessage="Description"
                    />
                </div>
                <h2 className={style('title')}>{title}</h2>
            </Gap>
            <Gap className={style('amount')}>
                <div className={style('label')}>
                    <FormattedMessage id="account.free-bet.amount" defaultMessage="Amount" />
                </div>
                <FormattedNumber value={grantedAmount} currency={currency} style={'currency'} />
            </Gap>
            <Gap className={style('expiry')}>
                <div className={style('label')}>
                    <FormattedMessage id="account.free-bet.expires" defaultMessage="Expires" />
                </div>
                {expiresOn ? (
                    <time>
                        <FormattedDate value={expiresOn} />
                    </time>
                ) : (
                    <FormattedMessage
                        id="account.free-bet.expires.no-expiration"
                        defaultMessage={'No Expiration'}
                    />
                )}
            </Gap>
        </div>
    );
};
